import * as React from 'react';
import {connect} from 'react-redux';
import * as selectors from '../selectors';
import DownloadState from '../DownloadState';
import {FeaturesByType, Operation} from '../../../../integration/representation/feature';
import {Checkbox, InputGroup} from 'react-bootstrap';
import {toggleSelectedFeatureTypeIds, ToggleSelectedFeatureTypeIds} from '../actions';
import {Destination} from '../../../../integration/representation/contract';

interface TagProps {
}

interface DispatchProps {
    doToggleSelectedFeatureTypeIds: ToggleSelectedFeatureTypeIds;
}

interface StateProps {
    destination: Destination;
    operations: Operation[];
    featuresByType: FeaturesByType[];
    selectedFeatureTypeIds: number[];
}

type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: DownloadState): StateProps => {
    return {
        destination: selectors.destination(state),
        operations: selectors.operations(state),
        featuresByType: selectors.featuresByTypeAndDestination(state),
        selectedFeatureTypeIds: selectors.selectedFeatureTypeIds(state)
    };
};

const mapDispatchToProps: DispatchProps = ({
    doToggleSelectedFeatureTypeIds: toggleSelectedFeatureTypeIds
});

class Component extends React.Component<Props, {}> {

    handleSelectedFeatureTypesChange(e: any, typeId: any) {
        this.props.doToggleSelectedFeatureTypeIds(typeId);
    }

    numberOfDownloadableObjectsWithCurrentOptions(featuresByType: FeaturesByType): number {
        const { destination, operations } = this.props;
        return featuresByType.features
            .filter(feature => feature.destination === destination)
            .filter(feature => operations.some(op => feature.operation === op))
            .length;
    }

    getInfoText(featuresByType: FeaturesByType) {
        const numberOfDownloadable = this.numberOfDownloadableObjectsWithCurrentOptions(featuresByType);
        if (numberOfDownloadable === 0) {
            return 'Ingen vegobjekter med valgt operasjon.';
        } else if (numberOfDownloadable === 1) {
            return '1 vegobjekt med valgt operasjon.';
        } else {
            return numberOfDownloadable + ' vegobjekter med valgt operasjon.';
        }
    }

    render() {
        const { featuresByType, selectedFeatureTypeIds } = this.props;

        return (
            <>
                <InputGroup className={'mb-3'}>
                    {featuresByType.map(featureByType => {
                        return (
                            <InputGroup key={featureByType.type.typeId} className={'download-inputgroup'}>
                                <Checkbox
                                    className={'download-checkbox'}
                                    checked={selectedFeatureTypeIds.indexOf(featureByType.type.typeId) !== -1}
                                    onChange={(e) =>
                                        this.handleSelectedFeatureTypesChange(e, featureByType.type.typeId)}>
                                    <span className={'text-bold'}>{featureByType.type.name}</span>
                                    &nbsp;
                                    <span className={'text-bold color-mid-gray'}>{featureByType.type.typeId}</span>
                                </Checkbox>
                                <p className={'subtext'}>{this.getInfoText(featureByType)}</p>
                            </InputGroup>
                        );
                    })}
                </InputGroup>
            </>
        );
    }
}

export const ObjectList = connect(mapStateToProps, mapDispatchToProps)(Component);
